// cart-prompt.guard.ts
import { Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class CartPromptGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private router: Router) { }

  canDeactivate(component: CanComponentDeactivate): boolean | Observable<boolean> {
    const targetUrl = this.router.getCurrentNavigation()?.finalUrl?.toString();
    if (targetUrl === '/place-order') return true;

    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
